import { Box, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    border: '1.5px solid #F37320',
    borderRadius: '4px',
    color: '#F37320',
    fontFamily: 'Roboto, sans-serif',
    background: '#ffffff',
    '&:hover': {
      background: '#ffffff',
    },
    padding: '6px 14px',
  },
}))

function OutlinedButton(props) {
  const classes = useStyles()

  return (
    <Button
      {...props}
      className={classes.root}
      disableRipple
      disableFocusRipple
      style={{ height: props.height || 'auto', width: props.width || 'auto' }}
    >
      {props.label}
    </Button>
  )
}

export default OutlinedButton
